/**
 * Portal Manta · agColetorKPI
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { extKm } from '../../globals.js';

function agColetorKPI(ctx, prev){
  const {kpis} = ctx;
  if (!kpis) return {status:'idle', msg:'aguardando KPIs'};
  const erros = [];
  if (!kpis.nome?.trim()) erros.push('Nome do estudo obrigatório');
  if (!kpis.uf) erros.push('UF obrigatória');
  if (!kpis.extKm || kpis.extKm <= 0) erros.push('Extensão deve ser > 0');
  const somaCtx = (kpis.ctxRural||0)+(kpis.ctxUrbano||0)+(kpis.ctxSerra||0);
  const aviso_ctx = Math.abs(somaCtx-1)>0.05 ? `soma contextos = ${(somaCtx*100).toFixed(0)}% (ideal 100%)` : null;
  return {
    sub:'Coletor de KPIs',
    status: erros.length===0?'ok':'erro',
    msg: erros.length===0?'KPIs validados':'erros: '+erros.join('; '),
    erros,
    aviso_ctx,
    qtds_resumo: { extKm:kpis.extKm, oaeQt:kpis.oaeQt, dupKm:kpis.dupKm, ciclKm:kpis.ciclKm },
    contexto_resumo: { uf:kpis.uf, regiao: UF_REGIAO[kpis.uf]||'?', chuva: kpis.chuvaMM+'mm/ano' },
  };
}

export { agColetorKPI };
export default agColetorKPI;
